import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`

export const ActivityName = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Measuring = styled.div`
  display: inline-flex;
  align-items: flex-end;
  column-gap: 4px;
`

export const Distance = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 40px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Unit = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Duration = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color6b7786};
`
